"use strict";

(function () {
  "use strict";

  angular.module("schedules.planning").factory("PlanningCells", PlanningCells);

  function PlanningCells() {
    var TZ = "Europe/Paris";

    var overlaps = function overlaps(period, start, end) {
      return period.start < end && period.end > start;
    };

    var at = function at(date, time) {
      return moment.tz(date + " " + time, "YYYY-MM-DD HH:mm", TZ).toDate();
    };

    // Reproduit getSlotFromSchedule de l'API pour afficher les mêmes occurrences que les créneaux proposés à la réservation.
    function getScheduleOccurrences(schedule, from, to) {
      if (!schedule || !schedule.fromDate || !schedule.startTime || !schedule.endTime) {
        return [];
      }

      var days;

      if (schedule.rrule && schedule.rrule.rrule) {
        var rule = RRule.rrulestr(schedule.rrule.rrule, {
          dtstart: new Date(schedule.fromDate)
        });
        var endOfGeneration = to;
        var configuredEnd = schedule.endDate || schedule.rrule.until;

        if (configuredEnd) {
          // La date de fin est saisie à minuit heure de Paris : on inclut toute la journée.
          var inclusiveEnd = at(moment(configuredEnd).tz(TZ).format("YYYY-MM-DD"), "23:59");
          inclusiveEnd = new Date(inclusiveEnd.getTime() + 59999);
          if (inclusiveEnd < endOfGeneration) {
            endOfGeneration = inclusiveEnd;
          }
          rule = new RRule(Object.assign({}, rule.origOptions, {
            dtstart: new Date(schedule.fromDate),
            until: inclusiveEnd
          }));
        }

        days = rule.between(from, endOfGeneration, true);
      } else {
        days = [new Date(schedule.fromDate)];
      }

      return days.map(function (day) {
        var date = moment(day).tz(TZ).format("YYYY-MM-DD");
        return { start: at(date, schedule.startTime), end: at(date, schedule.endTime) };
      }).filter(function (occurrence) {
        return occurrence.end > from && occurrence.start < to;
      });
    }

    // Fusionne les périodes qui se touchent ou se chevauchent.
    function mergePeriods(periods) {
      var merged = [];
      periods.slice().sort(function (a, b) {
        return a.start - b.start;
      }).forEach(function (period) {
        var last = merged[merged.length - 1];
        if (last && period.start <= last.end) {
          if (period.end > last.end) last.end = period.end;
        } else {
          merged.push({ start: period.start, end: period.end });
        }
      });
      return merged;
    }

    // Conserve les bornes réelles pour les actions, et ajoute les bornes à afficher pour la journée.
    function withDayDisplay(period, dayStart, dayEnd) {
      return Object.assign({}, period, {
        displayStart: period.start < dayStart ? dayStart : period.start,
        displayEnd: period.end > dayEnd ? dayEnd : period.end,
        coversDay: period.start <= dayStart && period.end >= dayEnd,
        displayEndsAtMidnight: period.end >= dayEnd
      });
    }

    // Résume une journée : amplitude de travail, pauses (trous entre périodes travaillées) et fermetures.
    function buildDayCell(occurrences, closures, dayStart, dayEnd) {
      var worked = mergePeriods(occurrences.filter(function (occurrence) {
        return overlaps(occurrence, dayStart, dayEnd);
      }));
      if (!worked.length) {
        return { work: null, pauses: [], closures: [], closedAllDay: false };
      }

      var pauses = worked.slice(1).map(function (period, index) {
        return { start: worked[index].end, end: period.start };
      });

      var dayClosures = closures.filter(function (closure) {
        return worked.some(function (period) {
          return overlaps(closure, period.start, period.end);
        });
      }).map(function (closure) {
        return withDayDisplay(closure, dayStart, dayEnd);
      }).sort(function (a, b) {
        return a.start - b.start;
      });

      var closedPeriods = mergePeriods(dayClosures);
      var closedAllDay = worked.every(function (period) {
        return closedPeriods.some(function (closed) {
          return closed.start <= period.start && closed.end >= period.end;
        });
      });

      return {
        work: { start: worked[0].start, end: worked[worked.length - 1].end },
        pauses: pauses,
        closures: dayClosures,
        closedAllDay: closedAllDay
      };
    }

    // Les fermetures sont des DEPA au statut « Fermé », regroupées par conseiller.
    function closuresByOperator(slots) {
      var byOperator = {};
      slots.forEach(function (slot) {
        if (slot.status !== "Fermé" || !slot.slot) return;
        var operatorId = (slot.slot.operatorId || "").replace(/^\$/, "");
        (byOperator[operatorId] = byOperator[operatorId] || []).push({
          id: slot._id,
          start: new Date(slot.slot.start),
          end: new Date(slot.slot.end),
          note: slot.note
        });
      });
      return byOperator;
    }

    // Liste dans l'ordre des heures les ouvertures, les pauses et les fermetures d'une journée.
    function buildDayDetail(schedules, closures, dayStart, dayEnd) {
      var opened = [];
      schedules.forEach(function (schedule) {
        getScheduleOccurrences(schedule, dayStart, dayEnd).forEach(function (occurrence) {
          opened.push({
            type: "open",
            id: schedule._id,
            start: occurrence.start,
            end: occurrence.end,
            name: schedule.name,
            note: schedule.note,
            customersCount: (schedule.enabledCustomersId || []).length
          });
        });
      });

      var worked = mergePeriods(opened);
      var pauses = worked.slice(1).map(function (period, index) {
        return { type: "pause", start: worked[index].end, end: period.start };
      });

      var closed = closures.filter(function (closure) {
        return overlaps(closure, dayStart, dayEnd);
      }).map(function (closure) {
        return Object.assign({ type: "closed" }, withDayDisplay(closure, dayStart, dayEnd));
      });

      var order = { open: 0, pause: 1, closed: 2 };
      return opened.concat(pauses, closed).sort(function (a, b) {
        return a.start - b.start || order[a.type] - order[b.type];
      });
    }

    return {
      getScheduleOccurrences: getScheduleOccurrences,
      buildDayCell: buildDayCell,
      buildDayDetail: buildDayDetail,
      closuresByOperator: closuresByOperator
    };
  }
})();